<template>
	<div>
		<el-table
			:data="tableData"
			size="small"
			:header-cell-style="setHeader"
			border
		>
			<el-table-column
				label="变动原因"
				align="center"
				prop="show_name"
			></el-table-column>
			<el-table-column
				label="变动数值"
				align="center"
				prop="show_num"
			></el-table-column>
			<el-table-column
				label="时间"
				align="center"
				prop="create_time"
			></el-table-column>
		</el-table>
		<div class="page">
			<el-pagination
				background
				layout="prev, pager, next, total"
				:current-page="page"
				:total="total"
				:page-size="10"
				@current-change="handleCurrentChange"
			>
			</el-pagination>
		</div>
	</div>
</template>

<script>
import { getUserPointLogs } from "@/api/vip";
import { mapGetters } from "vuex";
export default {
	props: {
		uid: {
			type: String,
			default: "",
		},
	},
	watch: {
		uid(val) {
			console.log("uid", val);
			this.getData();
		},
	},
	data() {
		return {
			tableData: [],
			page: 1, // 页码
			total: 0, // 总数
			headerStyle: {
				//表头样式
				background: "rgba(250,250,250,1)",
				color: "#000000",
			},
		};
	},
	computed: {
		...mapGetters(["token", "app_id"]),
	},
	mounted() {
		this.getData();
	},
	methods: {
		getData() {
			var data = {
				token: this.token,
				app_id: this.app_id,
				uid: this.uid,
				page: this.page,
			};
			getUserPointLogs(data).then((res) => {
				if (res.code == 200) {
					this.tableData = res.data.data;
					this.total = res.data.total;
					this.tableData.forEach((item) => {
						item.show_name =
							item.style == 0
								? "签到送积分"
								: item.style == 1
								? "线下买单"
								: item.style == 2
								? "充值"
								: item.style == 3
								? "后台变动"
								: item.style == 4
								? "回退"
								: item.style == 5
								? "其他"
								: item.style == 6
								? "积分兑换"
								: item.style == 7
								? "邀请新人"
								: item.style == 8
								? "员工端"
                : item.style == 9
								? "抽奖抵扣"
                : item.style == 10
								? "中奖发放"
                : item.style == 11
								? "抖音活动"
								: "";
						item.show_num =
							item.type == 1
								? "+" + item.num
								: item.type == 2
								? "-" + item.num
								: "";
					});
				}
			});
		},
		handleCurrentChange(val) {
			this.page = val;
			this.getData();
		},
		setHeader({ rowIndex }) {
			// 设置表头颜色
			if (rowIndex === 0) {
				return this.headerStyle;
			} else {
				return "";
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.page {
	margin-top: 20px;
}
</style>
